import { toast } from "react-toastify";

function errorHandler(error) {
  const message =
    error.response?.data?.message ||
    "서버에 문제가 있습니다. 잠시후 다시 시도해주세요.";

  switch (error.response?.status) {
    case 401:
      break;
    case 406:
      break;
    case 403:
      break;

    case 500:
      toast(message);
      break;
    default:
      toast(message);
      break;
  }
}

export { errorHandler };
